import React, { Component } from 'react';

export default class GroupCharts extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.chart = echarts.init(this.refs.chart);
        this.chart2 = echarts.init(this.refs.chart2);
        this.chart3 = echarts.init(this.refs.chart3);
        let dataSource =  this.props.dataSource;
        let dataSource2 =  this.props.dataSource2;
        if(dataSource) {
            this.initCharts(dataSource);
            this.initCharts2(dataSource2);
            this.initCharts3(dataSource, dataSource2);
        } 
    }

    componentWillReceiveProps(nextProps) {
        this.chart = echarts.init(this.refs.chart);
        this.chart2 = echarts.init(this.refs.chart2);
        this.chart3 = echarts.init(this.refs.chart3);
        let dataSource =  nextProps.dataSource;
        let dataSource2 =  nextProps.dataSource2;
        this.props = nextProps;
        if(dataSource) {
            this.initCharts(dataSource);
            this.initCharts2(dataSource2);
            this.initCharts3(dataSource, dataSource2);
        }
    }

    initCharts(dataSource) {
        let option = {
            title: {
                text: dataSource.orgName + '填报率',
            },
            tooltip: {
                formatter: '{a} <br/>{b} : {c}%'
            },
            toolbox: {
                feature: {
                }
            },
            series: [
                {
                    name: dataSource.orgName || '',
                    type: 'gauge',
                    axisLine: {
                      lineStyle: {
                        width: 20,
                        color: [
                          [0.3, '#fd666d'],
                          [0.7, '#37a2da'],
                          [1, '#67e0e8']
                        ]
                      }
                    },
                    detail: {formatter: '{value}%'},
                    data: [{value: 50, name: '填报率'}]
                }
            ]
        };
        option.series[0].data[0].value = dataSource.allFillingRate;
        
        this.chart.setOption(option, true);
    }

    initCharts2(dataSource) {
      let option = {
          title: {
              text: dataSource.orgName + '达标率',
          },
          tooltip: {
              formatter: '{a} <br/>{b} : {c}%'
          },
          toolbox: {
              feature: {
              }
          },
          series: [
              {
                  name: dataSource.orgName || '',
                  type: 'gauge',
                  axisLine: {
                    lineStyle: {
                      width: 20,
                      color: [
                        [0.3, '#fd666d'],
                        [0.7, '#37a2da'],
                        [1, '#67e0e8']
                      ]
                    }
                  },
                  detail: {formatter: '{value}%'},
                  data: [{value: 50, name: '达标率'}]
              }
          ]
      };
      option.series[0].data[0].value = dataSource.allComplianceRate;
      
      this.chart2.setOption(option, true);
    }

    initCharts3(dataSource,dataSource2) {
        let option = {
            title: {
                text: '填报及达标人数组成',
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                    type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                },
                formatter: function (params) {
                    var tar = params[1];
                    return tar.name + '<br/>' + tar.seriesName + ' : ' + tar.value;
                }
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: {
                type: 'category',
                splitLine: {show: false},
                data: ['总申报人数', '已填报人数', '未填报人数', '总填报人数', '已达标人数', '未达标人数']
            },
            yAxis: {
                type: 'value'
            },
            series: [
                {
                    name: '辅助',
                    type: 'bar',
                    stack: '总量',
                    itemStyle: {
                        barBorderColor: 'rgba(0,0,0,0)',
                        color: 'rgba(0,0,0,0)'
                    },
                    emphasis: {
                        itemStyle: {
                            barBorderColor: 'rgba(0,0,0,0)',
                            color: 'rgba(0,0,0,0)'
                        }
                    },
                    data: [0, dataSource.allSumCount - dataSource.allFillingCount,  0, 0, dataSource2.allSumCount - dataSource2.allComplianceCount, 0]
                },
                {
                    name: '人数',
                    type: 'bar',
                    stack: '总量',
                    label: {
                        show: true,
                        position: 'inside'
                    },
                    data: [dataSource.allSumCount, dataSource.allFillingCount, dataSource.allSumCount - dataSource.allFillingCount, dataSource2.allSumCount, dataSource2.allComplianceCount, dataSource2.allSumCount - dataSource2.allComplianceCount]
                }
            ]
        }
        this.chart3.setOption(option, true);

    }

    render() {
        const height = this.props.height ? this.props.height : 350;
        return (
            <div style={{width:'100%',height,marginTop: 20}}>
                <div style={{float:'left',width:'25%',height,display: 'inline'}} ref="chart"></div>
                <div style={{float:'left',width:'25%',height,display: 'inline'}} ref="chart2"></div>
                
                <div style={{float:'left',width:'50%',height,display: 'inline'}} ref="chart3"></div>
            </div> 
        )
    }
}
